// extracted by mini-css-extract-plugin
module.exports = {"selectedStatus":"status-module__selectedStatus___1jsiq"};